<app-navbar-style-three></app-navbar-style-three>

<section class="achievements-section">
  <div class="container">
    <!-- Header with Decorative Elements -->
    <div class="section-header">
      <div class="section-header__decoration">
        <svg class="trophy-icon" width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M6 9C6 10.5913 6.63214 12.1174 7.75736 13.2426C8.88258 14.3679 10.4087 15 12 15C13.5913 15 15.1174 14.3679 16.2426 13.2426C17.3679 12.1174 18 10.5913 18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 15V19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 19H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 9H3C3 10.06 3.21 11 4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 9H21C21 10.06 20.79 11 20 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6 5H18V9H6V5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="section-title">Achievements</h1>
      <p class="section-subtitle">Celebrating excellence and milestones</p>
    </div>

    <!-- Achievements Grid -->
    <ng-container *ngIf="News_event_data != null && News_event_data.length > 0">
      <div class="achievements-grid">
        <article 
          class="achievement-card"
          *ngFor="let item of News_event_data; let i = index"
          [attr.data-index]="i"
        >
          <div class="achievement-card__badge">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
            </svg>
          </div>

          <div class="achievement-card__image-wrapper">
            <img 
              [src]="item.ShowAttachments[0].FilePath" 
              [alt]="item.TitleEn"
              class="achievement-card__image"
              loading="lazy"
            />
            <div class="achievement-card__overlay"></div>
          </div>
          
          <div class="achievement-card__content">
            <h2 class="achievement-card__title">{{ item.TitleEn }}</h2>
            <div class="achievement-card__excerpt" [innerHTML]="item.DetailsEn"></div>
            <a 
              [routerLink]="['/achievements', item.Id]" 
              class="achievement-card__link"
            >
              <span>Read more</span>
              <svg class="link-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
        </article>
      </div>
    </ng-container>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="News_event_data == null || News_event_data.length === 0">
      <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="empty-state__text">No achievements to display at the moment.</p>
    </div>
  </div>
</section>